import dayjs from 'dayjs';
import Constants from '../assests/Constants/constants.js';

/** Staff can always process. Clients can process only with Premium and without hideStatus. */
export const canProcessDocumentStatus = (userTypeContext, permissionsState, hideStatus = false) => {
    const isClient = userTypeContext?.toString() === Constants.UserType.Client;
    if (!isClient) return true;
    return Boolean(permissionsState?.Premium) && !hideStatus;
};

export const getInitials = (name) => {
    if (!name) return "N/A";
    return name
        .split(" ")
        .map((word) => word[0])
        .join("");
};


// export const getInitials = (name) => {
//     if (!name) return "N/A";
//     return name
//         .split(" ")
//         .map((word) => word[0].toUpperCase())
//         .join("");
// };


/** SHAAM rejects customer_vat_number below 10 (including 0). */
export const isValidShaamCustomerVatNumber = (value) => {
    if (value === null || value === undefined || value === '') return false;
    const n = Number(String(value).trim());
    return Number.isFinite(n) && n >= 10;
};

export const validateEmail = (email) => {
    if (!email || email.trim() === '') return true; // Allow empty email

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};



export const validatePhoneNumber = (phoneNumber) => {
    if (!phoneNumber || phoneNumber.toString().trim() === '') return true; // Allow empty phone number

    const digitsOnly = phoneNumber.toString().replace(/\D/g, '');
    return digitsOnly.length === 9 || digitsOnly.length === 10;
};

const applyIsraeliPhoneDash = (digits) => {
    if (!digits) return digits;
    if (digits.startsWith('05') && digits.length > 3) {
        return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    }
    if (digits.startsWith('0') && digits.length > 2) {
        return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    }
    return digits;
};

/** Digits-only Israeli phone for API/storage (e.g. 0505322621). */
export const normalizeIsraeliPhoneNumberForStorage = (phoneNumber) => {
    if (!phoneNumber || phoneNumber.toString().trim() === '') return phoneNumber;

    const digitsOnly = phoneNumber.toString().replace(/\D/g, '');
    if (!digitsOnly) return phoneNumber.toString().trim();

    if (digitsOnly.length === 10 && digitsOnly.startsWith('0')) return digitsOnly;
    if (digitsOnly.length === 9 && digitsOnly.startsWith('0')) return digitsOnly;
    if (digitsOnly.length === 9 || digitsOnly.length === 8) return `0${digitsOnly}`;
    return digitsOnly;
};

/** Display format with dash (e.g. 050-5322621). */
export const formatIsraeliPhoneNumber = (phoneNumber) => {
    if (!phoneNumber || phoneNumber.toString().trim() === '') return phoneNumber;

    const normalized = normalizeIsraeliPhoneNumberForStorage(phoneNumber);
    if (!normalized || typeof normalized !== 'string') return phoneNumber.toString().trim();

    return applyIsraeliPhoneDash(normalized);
};


export const getBiMonthlyRange = () => {
    const currentMonth = dayjs().month() + 1; // getMonth() returns 0-based index, so add 1
    let startMonth, endMonth;

    if (currentMonth >= 1 && currentMonth <= 2) {
        startMonth = 1;
        endMonth = 2;
    } else if (currentMonth >= 3 && currentMonth <= 4) {
        startMonth = 3;
        endMonth = 4;
    } else if (currentMonth >= 5 && currentMonth <= 6) {
        startMonth = 5;
        endMonth = 6;
    } else if (currentMonth >= 7 && currentMonth <= 8) {
        startMonth = 7;
        endMonth = 8;
    } else if (currentMonth >= 9 && currentMonth <= 10) {
        startMonth = 9;
        endMonth = 10;
    } else {
        startMonth = 11;
        endMonth = 12;
    }

    const year = dayjs().year();

    // Adjust for timezone offset to ensure accurate local time
    const adjustToDate = (date) => {
        const startOfMonth = dayjs(date).startOf('month');
        const offset = startOfMonth.utcOffset();
        return startOfMonth.add(offset, 'minute').toDate();
    };

    return {
        startDateBi: adjustToDate(`${year}-${startMonth}-01`),
        endDateBi: adjustToDate(dayjs(`${year}-${endMonth}-01`).endOf('month')),
    };
};


export function getBiMonthlyRangeByDate(date) {
    // For a “normal” Date object, consider getUTCFullYear() / getUTCMonth() 
    // if you’ve been dealing with all UTC logic. 
    // If not strictly in UTC, switch to getFullYear() / getMonth().
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth(); // 0-based: Jan = 0, Feb = 1, ...

    // Bi-monthly blocks in pairs (Jan-Feb, Mar-Apr, etc.)
    const biMonthlyPeriods = [
        { label: '1-2', value: 0 },   // Jan-Feb
        { label: '3-4', value: 2 },   // Mar-Apr
        { label: '5-6', value: 4 },   // May-Jun
        { label: '7-8', value: 6 },   // Jul-Aug
        { label: '9-10', value: 8 },  // Sep-Oct
        { label: '11-12', value: 10 } // Nov-Dec
    ];

    // Figure out which 2-month block 'month' falls into
    // e.g. month=0 or 1 => index=0 => block is 1-2, so startMonth=0, endMonth=1
    const index = Math.floor(month / 2); // 0..5
    const startMonth = biMonthlyPeriods[index].value;   // e.g. 0
    const endMonth = startMonth + 1;                    // e.g. 1

    // Construct start/end in UTC, inclusive of last second of end month
    // i.e. endMonth + 1 -> day 0 => last day of that next month’s “previous” day
    const startDate = new Date(Date.UTC(year, startMonth, 1));
    const endDate = new Date(Date.UTC(year, endMonth + 1, 0, 23, 59, 59, 999));

    return [startDate, endDate];
}
